import { render, staticRenderFns } from "./ClientRoleEdit.vue?vue&type=template&id=692a7f2a&scoped=true&"
import script from "./ClientRoleEdit.vue?vue&type=script&lang=js&"
export * from "./ClientRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692a7f2a",
  null
  
)

export default component.exports